module.exports = __webpack_public_path__ + "img/Family_In_front_House.7b623ad.jpg";